import { createIcon } from '@consta/icons/Icon'
import type { FC, SVGProps } from 'react'

const IconGeomoduleM: FC<SVGProps<SVGSVGElement>> = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
      <g clipPath="url(#clip0_128199_2014)">
        <path d="M8.57687 0.156459C8.2206 -0.0521529 7.7794 -0.0521533 7.42313 0.156459L0.56454 4.17245C-0.189107 4.61374 -0.18795 5.70323 0.566636 6.14292L7.42523 10.1393C7.78044 10.3463 8.21956 10.3463 8.57477 10.1393L15.4334 6.14292C16.188 5.70323 16.1891 4.61374 15.4355 4.17245L8.57687 0.156459ZM7.42313 1.47886C7.7794 1.27025 8.2206 1.27025 8.57687 1.47886L14.8586 5.15707L8.57477 8.81858C8.21956 9.02556 7.78044 9.02556 7.42523 8.81858L1.14141 5.15707L7.42313 1.47886ZM0.0918836 7.6116L7.44029 11.7451C7.78781 11.9406 8.21219 11.9406 8.55971 11.7451L15.9081 7.61163C16.1215 8.11171 15.9631 8.74065 15.4334 9.04934L8.57477 13.0458C8.21956 13.2527 7.78044 13.2527 7.42523 13.0458L0.566636 9.04934C0.0368742 8.74065 -0.121535 8.11169 0.0918836 7.6116ZM0.0918836 10.4106L7.44029 14.5441C7.78781 14.7396 8.21219 14.7396 8.55971 14.5441L15.9081 10.4106C16.1215 10.9107 15.9631 11.5397 15.4334 11.8483L8.57477 15.8448C8.21956 16.0517 7.78044 16.0517 7.42523 15.8448L0.566636 11.8483C0.0368742 11.5397 -0.121535 10.9107 0.0918836 10.4106Z" />
      </g>
      <defs>
        <clipPath id="clip0_128199_2014">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const IconGeomodule = createIcon({
  l: IconGeomoduleM,
  m: IconGeomoduleM,
  s: IconGeomoduleM,
  xs: IconGeomoduleM,
  name: 'IconGeomodule',
})
